// Fatura Raporları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.invoiceReports';

export const invoiceReportsGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Fatura Raporları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Seçtiğiniz tarih aralığındaki satış, alış ve hızlı satış faturalarını, silinmiş olanlar dahil listeler ve Excel\'e aktarır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Fatura Raporları'),
    actions: t(`${G}.regions.actions`, 'Filtreler / Excel İndir'),
    filters: t(`${G}.regions.filters`, 'Tarih ve filtreler'),
    table: t(`${G}.regions.table`, 'Fatura listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu rapor ne gösterir?'),
      text: t(`${G}.s1.text`, 'Rapor, fatura kayıtlarını silinmiş olanlarla birlikte gösterir; böylece hangi faturanın ne zaman kaydedildiğini ve silinip silinmediğini izlersiniz. Sayfa açıldığında liste boştur; tarih seçip "Filtrele"ye basmanız gerekir.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Tarih aralığını ve filtreleri seçin'),
      text: t(`${G}.s2.text`, 'Başlangıç Tarihi ve Bitiş Tarihi (saatle birlikte) zorunludur; ikisi seçilmeden "Filtrele" açılmaz. Fatura Tipi: Tümü, Satış, Alış veya Hızlı Satış. Durum: Tümü, Sadece Aktif veya Sadece Silinen.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tarih aralığı faturanın sisteme kaydedildiği tarihe (Oluşturma Tarihi) göre uygulanır, fatura tarihine göre değil.'),
        t(`${G}.s2.tip2`, 'Durum varsayılan olarak Tümü\'dür; silinmiş faturalar da listeye gelir.'),
        t(`${G}.s2.tip3`, 'Üstteki "Filtreleri Gizle / Göster" düğmesi filtre alanını açıp kapatır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Tabloyu okuyun'),
      text: t(`${G}.s3.text`, 'Sütunlar: Fatura No, Tür, Cari Hesap, Fatura Tarihi, Toplam Tutar, Durum (Aktif / Silindi) ve Oluşturma Tarihi. Sıralamak için sütun başlığına tıklayın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Toplam Tutar, faturanın kendi para birimindeki KDV dahil genel toplamıdır.'),
        t(`${G}.s3.tip2`, 'Bu rapor KDV ayrıntısı göstermez ve listelenen faturaların genel toplamını hesaplamaz.'),
      ],
    },
    {
      region: 'actions',
      title: t(`${G}.s4.title`, '4. Excel\'e aktarın'),
      text: t(`${G}.s4.text`, '"Excel İndir", listelenen satırları Fatura No, Tür, Cari Hesap, Fatura Tarihi, Vade Tarihi, Para Birimi, Toplam Tutar, Durum ve Oluşturma Tarihi sütunlarıyla indirir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Yalnız o an ekranda görünen sayfa indirilir; daha fazla satır için önce sayfa başına satır sayısını artırın.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sayfalar arasında gezin'),
      text: t(`${G}.s5.text`, 'Sonuç uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına kaç satır görüneceğini seçin. Sol üstteki geri düğmesi önceki sayfaya döner; başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
